import { useContext } from 'react';
import WsContext from '../providers/WsProvider';

const useWs = () => useContext(WsContext);

export default useWs;
